import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./AboutSection.css";

import { FiTarget, FiZap, FiShield, FiArrowRight } from "react-icons/fi";

const AboutSection = () => {
  const aboutRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const section = aboutRef.current;

    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          section.classList.add("about-visible");
          observer.unobserve(section);
        }
      },
      {
        threshold: 0.3,
        rootMargin: "0px 0px -100px 0px",
      },
    );

    observer.observe(section);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="about-section" ref={aboutRef}>
      <div className="about-container">
        {/* Left Content */}
        <div className="about-content">
          <span className="about-label">ABOUT US</span>

          <h2>
            A Technology Partner
            <br />
            You Can Trust
          </h2>

          <p>
            MindstreamX Technologies is a forward-thinking IT company dedicated
            to delivering innovative, reliable, and scalable technology
            solutions that help businesses transform ideas into reality.
          </p>

          <button
            type="button"
            className="about-btn"
            onClick={() => navigate("/about-us")}
          >
            <span>Learn More About Us</span>
            <FiArrowRight />
          </button>

          {/* Company Values */}
          <div className="about-features">
            <div className="feature-item">
              <div className="feature-icon">
                <FiTarget />
              </div>

              <small>
                Customer
                <br />
                Focused
              </small>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <FiZap />
              </div>

              <small>
                Innovation
                <br />
                Driven
              </small>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <FiShield />
              </div>

              <small>
                Integrity &
                <br />
                Transparency
              </small>
            </div>
          </div>
        </div>

        {/* Center Image */}
        <div className="about-image">
          <img
            src="/images/team-collaboration.png"
            alt="MindstreamX Technologies team working together"
          />
        </div>

        {/* Right Mission */}
        <div className="about-mission">
          <span className="mission-label">OUR MISSION</span>

          <h3>
            Empowering
            <br />
            Businesses
            <br />
            Through Technology
          </h3>

          <div className="mission-line"></div>

          <p>
            We deliver innovative and scalable technology solutions that help
            businesses grow and succeed.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
